<template>
  <v-layout wrap>
    <v-flex v-if="Object.keys(conselhoGetter).length > 0">
      <v-layout>
        <v-flex>
          <v-radio-group
            v-model="conselho.tp_governamental"
            disabled
            row
          >
            <v-radio
              label="Estadual"
              value="e"
            />
            <v-radio
              label="Capital"
              value="c"
            />
          </v-radio-group>
        </v-flex>
      </v-layout>


      <v-layout>
        <v-flex>
          <v-text-field
            v-model="conselho.nu_cnpj"
            label="CNPJ do Orgão Gestor do Conselho"
            append-icon="people"
            mask="##.###.###/####-##"
            disabled
          />
        </v-flex>
      </v-layout>


      <v-layout>
        <v-flex>
          <v-text-field
            v-model="conselho.no_orgao_gestor"
            label="Nome do órgão gestor de cultura"
            append-icon="people"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="conselho.no_conselho"
            label="*Nome do conselho de cultura"
            append-icon="people"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="conselho.nu_telefone"
            label="Telefone do Conselho"
            append-icon="phone"
            mask="(##) #####-####"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="conselho.ds_email"
            label="E-mail do Conselho"
            append-icon="mail"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="conselho.ds_sitio_eletronico"
            label="Sítio eletrônico do conselho"
            append-icon="public"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.endereco || {}).nu_cep"
            label="CEP"
            append-icon="my_location"
            mask="#####-###"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.endereco || {}).ds_logradouro"
            label="Logradouro"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.endereco || {}).ds_complemento"
            label="Complemento"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.endereco || {}).no_bairro"
            label="Bairro"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-select
            v-model="(conselho.endereco || {}).co_ibge"
            :items="listaUF"
            label="Unidade da federação da sede"
            item-value="co_ibge"
            item-text="no_uf"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-select
            v-model="(conselho.endereco || {}).co_municipio"
            :items="listaMunicipios"
            label="Cidade"
            append-icon="location_city"
            item-value="co_municipio"
            item-text="no_municipio"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.representante || {}).no_nome"
            label="Nome do representante"
            append-icon="perm_identity"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.representante || {}).no_cargo"
            label="Cargo do representante"
            append-icon="assignment_ind"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.representante || {}).nu_telefone"
            label="Celular do representante"
            append-icon="phone"
            mask="(##) #####-####"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.representante || {}).nu_cpf"
            label="CPF"
            append-icon="branding_watermark"
            mask="###.###.###.##"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.representante || {}).nu_rg"
            label="RG"
            append-icon="account_box"
            mask="##.###.###-#"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(conselho.representante || {}).ds_email"
            label="E-mail do representante"
            append-icon="mail"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-flex 
        sm12 
        v-if="conselho.representante
              && conselho.representante.arquivos
              && conselho.representante.arquivos.length
              && (perfil.co_perfil == 1) || (perfil.co_perfil == 777)"
      >
        <v-btn v-for="arquivo in conselho.representante.arquivos" :key="arquivo.co_arquivo"
          color="blue-grey"
          class="white--text text-capitalize"
          @click.prevent="downloadArquivo(arquivo.co_arquivo)"
          flat
        >
          {{ arquivo.tp_arquivo | fileName }}
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
      </v-flex>

    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ConselhoDetalhesInscricaoVisualizacao',
  data: () => ({
    listaUF: [],
    listaMunicipios: [],
    conselho: {},
  }),
  computed: {
    ...mapGetters({
      conselhoGetter: 'conselho/conselho',
      estadosGetter: 'localidade/estados',
      municipiosGetter: 'localidade/municipios',
      perfil: "conta/perfil",
    }),
  },
  watch: {
    conselhoGetter(value) {
      this.conselho = value;
      this.loadMunicipios(this.conselho.endereco.co_ibge);

    },
    estadosGetter(value) {
      this.listaUF = value;
    },
    municipiosGetter(value) {
      this.listaMunicipios = value;
    },
  },
  mounted() {
    this.listaUF = this.estadosGetter;
    if (this.listaUF.length < 1) {
      this.obterEstados();
    }
    this.conselho = this.conselhoGetter;
    this.listaMunicipios = this.municipiosGetter;
    if (this.listaMunicipios.length < 1 && Object.keys(this.conselhoGetter).length > 0) {
     this.loadMunicipios(this.conselho.endereco.co_ibge);
    }
  },
  methods: {
    ...mapActions({
      downloadArquivo: 'shared/downloadArquivo',
    }),
    formatarDataCarbon(data) {
      if (data.length === 0 || !data.trim()) {
        return false;
      }
      const [dia, mes, ano] = data.split('/');

      return `${ano}-${(`0${mes}`).slice(-2)}-${(`0${dia}`).slice(-2)}`;
    },
    loadMunicipios(co_ibge) {
      this.obterMunicipios(co_ibge);
    },
    ...mapActions({
      obterEstados: 'localidade/obterEstados',
      obterMunicipios: 'localidade/obterMunicipios',
    }),

  },
  filters: {
    fileName: function (name) {
      if (!name) return ''
      name = name.toString()
      name = name.replace(/_/gi, " ");
      return name[0].toUpperCase() + name.slice(1)
    }
  }

};
</script>
